import { _axios } from "../axios";
import { AxiosResponse }  from "axios";

/**
 * Gets all help associated with a product
 *
 * @param productSlug
 * @returns {AxiosResponse<any>}
 */
export function getProductHelp( productSlug = '' ) {
    return _axios.get( '/products/' + productSlug + '/help' );
}